export default __webpack_public_path__ + "static/media/homeIcon.a30a9760.svg";